// import { SET_ROUND_TABLES_SHOW } from './../../Actions/Schedule/scheduleActions';
export const SHOW_SCHEDULE = "SHOW_SCHEDULE";
export const HIDE_SCHEDULE = "HIDE_SCHEDULE";
export const SET_LIVE_RESENTATION_SHOW ="SET_LIVE_RESENTATION_SHOW";
export const SET_LIVE_RESENTATION_HIDE ="SET_LIVE_RESENTATION_HIDE";
export const SET_PANEL_DISCUSSION_SHOW = "SET_PANEL_DISCUSSION_SHOW"
export const SET_PANEL_DISCUSSION_HIDE = "SET_PANEL_DISCUSSION_HIDE"
export const SET_ON_DEMAND_SHOW = "SET_ON_DEMAND_SHOW";
export const SET_ON_DEMAND_HIDE = "SET_ON_DEMAND_HIDE";
export const SET_ROUND_TABLES_SHOW="SET_ROUND_TABLES_SHOW";
export const SET_ROUND_TABLES_HIDE="SET_ROUND_TABLES_HIDE";
export const SET_BOOTH_SHOW="SET_BOOTH_SHOW";
export const SET_BOOTH_HIDE="SET_BOOTH_HIDE";
